import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Lilate, LilateStatus } from '../../../../../shared/src/lib/model/lilate.model';
import { LilateActionTypes } from '../../../../../shared/src/lib/store/actions/lilate.actions';
import * as lilateActions from '../../../../../shared/src/lib/store/actions/lilate.actions';
import { LilateService } from '../../../../../shared/src/lib/service/lilate.service';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-teacher-lilate-list',
  templateUrl: './teacher-lilate-list.component.html',
  styleUrls: ['./teacher-lilate-list.component.scss']
})
export class TeacherLilateListComponent implements OnInit, OnDestroy {
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  lilatesPendingAssements: Lilate[] = [];
  lilatesUpcoming: Lilate[] = [];
  last: Date;
  nextPendingAssements: boolean = false;
  nextUpcoming: boolean = false;
  pagePending = 0;
  pageUpcoming = 0;

  constructor(
    private lilateService: LilateService
  ) { }

  ngOnInit() {
    this.getLilatesUpcomings();
    this.getLilatesPendingAssessments();
  }

  getLilatesPendingAssessments(next = true) {
    this.pagePending = this.pagePending + 1;
    let params = new HttpParams();
    params = params.append('page', this.pagePending.toString());
    this.lilateService.getLilatesPendingAssessments(params).subscribe(
      lilates => {
        this.lilatesPendingAssements = next ? this.lilatesPendingAssements.concat(lilates.results) : lilates.results;
        this.nextPendingAssements = lilates.next ? true : false;
      }
    )
  }

  getLilatesUpcomings(next = true) {
    this.pageUpcoming = this.pageUpcoming + 1;
    let params = new HttpParams();
    params = params.append('page', this.pageUpcoming.toString());
    this.lilateService.getLilatesUpcomingsAssessments(params).subscribe(
      lilates => {
        this.lilatesUpcoming = next ? this.lilatesUpcoming.concat(lilates.results) : lilates.results;
        this.nextUpcoming = lilates.next ? true : false;
        this.last = lilates.last;
      }
    )
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  updateLilates() {
    this.pagePending = 0;
    this.pageUpcoming = 0;
    this.getLilatesUpcomings(false);
    this.getLilatesPendingAssessments(false);
  }
}
